import React, { useState, useContext, useEffect } from 'react';
import Cookie from 'universal-cookie';

import * as style from 'styles/components/homepage/matches.module.scss';
import NewsBanner from 'components/homepage/NewsBanner';
import MerchBlockList from 'components/merch/BlockList';
import NewsBlockListHomepage from 'components/news/BlockListHomepage';
import SponsorAdsBanner from 'components/homepage/SponsorAdsBanner';
import MatchesHomepage from 'components/homepage/Matches';
import Modal from 'components/utils/Modal';
import Splash from 'components/match/Splash';
import useHammarbyClub from 'data/queries/useHammarbyClub';
import useAllMatches from 'data/queries/useAllMatches';
import { LangContext } from 'context/LangContext';
import FormattedMessage from 'components/utils/FormattedMessage';
import Calendar from 'components/match/Calendar';

const Homepage = ({ pageContext }) => {
    const { lang } = useContext(LangContext);

    const club = useHammarbyClub();
    const allMatches = useAllMatches();

    const [filteredTeam, setFilteredTeam] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedMatchModal, setSelectedMatchModal] = useState(null);

    useEffect(() => {

        const now = new Date();
        const cookie = new Cookie();

        const selectedMatch = allMatches.find((match) => {
            const matchDate = new Date(match.startEventDate);

            if(!match.competition) return null;

            if (match.competition.title !== 'Allsvenskan' && match.competition.title !== 'OBOS Damallsvenskan 2023') return null;

            if (matchDate < now) return null;

            const diff = Math.abs(new Date(match.startEventDate)- new Date());
            const diffDays = Math.ceil(diff/ (1000 * 3600 * 24))

            if (diffDays <= 1) {
                if( !cookie.get('matchOverlayShown') ) {
                    cookie.set('matchOverlayShown', 'true', { path: '/' });
                    return match;
                }
            }
            return null
        })

        setSelectedMatchModal(selectedMatch)
        setShowModal(true)

    }, [allMatches, setSelectedMatchModal])

    const filteredNews = (items) =>
        items
            .filter(
                (item) =>
                    item.team.filter((team) => team.id === filteredTeam).length > 0 ||
                    filteredTeam === null,
            )
            .sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate))
            .slice(0, 5);

    return (
        <>
            <Modal show={showModal && selectedMatchModal} onClose={() => setShowModal(false)}>
                <Splash match={selectedMatchModal} />
            </Modal>

            <NewsBanner />

            <ul className="tabs wrapper" style={{ display: 'none' }}>
                <li>
                    <button
                        onClick={() => setFilteredTeam(null)}
                        className={filteredTeam === null ? 'active' : ''}
                        type="button"
                    >
                        <FormattedMessage id="global.allTeams" />
                    </button>
                </li>
                {club.teams.map((item, index) => (
                    <li key={index}>
                        <button
                            onClick={() => setFilteredTeam(item.id)}
                            className={filteredTeam === item.id ? 'active' : ''}
                            type="button"
                        >
                            {item.title[lang.translationKey] || item.title.en}
                        </button>
                    </li>
                ))}
            </ul>

            <MatchesHomepage
                allMatches={allMatches}
                filteredTeam={filteredTeam}
            />

            <SponsorAdsBanner />

            {pageContext.news.length > 0 && (
                <NewsBlockListHomepage
                    title={<FormattedMessage id="news.news" />}
                    items={filteredNews(pageContext.news)}
                />
            )}

            <div className={`${style.matches__calendar} wrapper hidden-desktop small-margin`}>
                <Calendar filteredTeam={filteredTeam} matches={allMatches} />
            </div>

            <MerchBlockList />
        </>
    );
};

export default Homepage;
